// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header_hluHd {
  padding: 10px 26px 10px 20px;
  text-align: right;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  border-bottom: 5px solid #F4F6FA;
}

.layout_hOicO {
  display : grid;
  grid-template-columns: 1fr 400px;
}

.editor_F97FH {
  border-left : 4px solid var( --color-base100, #eeeeee );
}

.padding_wy22P {
  padding : var( --size-padMedium, 8px ) 0;
}`, "",{"version":3,"sources":["webpack://./src/screens/oidc/OidcScreen.css"],"names":[],"mappings":"AAAA;EACE,4BAA4B;EAC5B,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,uDAAuD;AACzD;;AAEA;EACE,wCAAwC;AAC1C","sourcesContent":[".header {\n  padding: 10px 26px 10px 20px;\n  text-align: right;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  border-bottom: 5px solid #F4F6FA;\n}\n\n.layout {\n  display : grid;\n  grid-template-columns: 1fr 400px;\n}\n\n.editor {\n  border-left : 4px solid var( --color-base100, #eeeeee );\n}\n\n.padding {\n  padding : var( --size-padMedium, 8px ) 0;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `header_hluHd`,
	"layout": `layout_hOicO`,
	"editor": `editor_F97FH`,
	"padding": `padding_wy22P`
};
export default ___CSS_LOADER_EXPORT___;
